//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request } from '@/tools/index.js'
import { jssdk, isIphonex } from '@runwork/runwork-help'
import surveyList from './QuestionnaireList.vue'
import BottomNavigation from '@/components/navigation/Index.vue'
export default {
  name: 'index-page',
  data() {
    return {
      currentIndex: 0,
      dataList: [],
      listNum: [],
      oldTab: [],
      tabData: [],
      isRW3: undefined, // 平台标志 3.0 true
      isSurveyAdmin: false,
      currentPage: 1,
      totalPage: 1,
      pullUpLoad: {
        threshold: 0,
        txt: {
          more: '',
          noMore: '',
        },
      },
      pullDownRefresh: {
        threshold: 80,
        stop: 40,
        stopTime: 200,
        txt: '更新完成',
      },
    }
  },
  components: {
    surveyList,
    BottomNavigation,
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    status() {
      switch (this.currentIndex) {
        case 0:
          return 10
        case 1:
          return 20
        case 2:
          return 30
        default:
          return 10
      }
    },
  },
  watch: {
    currentIndex() {
      const loading = new this.$Loading()
      this.initList()
        .then(() => {
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
  },
  async created() {
    const loading = new this.$Loading()
    try {
      await this.$nativeBridgeReady()
      await this.init()
      console.log('平台：', window.h5sdk ? 3.0 : 2.0)
      this.isRW3 = window.h5sdk ? true : false
      loading.close()
    } catch (err) {
      console.log(err)
      loading.close()
    }
  },
  methods: {
    init() {
      let promiseArr = [this.getCreateTab(), this.checkSurveyAdmin()]
      return Promise.all(promiseArr)
    },
    initList() {
      let promiseArr = [this.getListData()]
      return Promise.all(promiseArr)
    },
    viewData(item) {
      this.$router.push({
        name: 'preview',
        query: {
          questionnaireId: item.tenantId,
          isQuestion: 1,
          preview: 1,
          currentListStatus: 10, // 当前列表状态
        },
      })
    },
    getCreateTab() {
      const params = {}
      return request('selectTemplateCategory', params).then((res) => {
        let list = res || []
        let array = []
        list.length > 0 &&
          list.forEach((element) => {
            array.push(element.name)
          })
        this.oldTab = list
        this.tabData = array
        if (list.length > 0) {
          this.getListData()
        }
      })
    },
    getListData(isAppend) {
      this.templateId = this.oldTab[this.currentIndex].tenantId
      const params = {
        templateClassifyId: this.templateId,
        commonPageDTO: {
          currentPage: this.currentPage,
          pageSize: 10,
        },
        sortDTO: {},
      }
      return request('getTemplateListByCategory', params).then((res) => {
        this.currentPage = res.currentPage
        this.totalPage = res.pageCount
        let list = res.recordList || []
        if (isAppend) {
          this.dataList = this.dataList.concat(list)
        } else {
          this.dataList = list
        }
      })
    },
    async create() {
      if (!this.isSurveyAdmin) {
        new this.$Toast({
          text: '暂无权限，请联系管理员开通相关权限',
          time: 1500,
          position: 'top',
          distance: '50%',
        })
        return
      } else {
        this.createQuestion()
      }
    },
    createQuestion() {
      const loading = new this.$Loading()
      return request('saveQuestion', {
        questionnaireId: '',
        userCode: this.user.ldap,
        title: '问卷标题',
        titleFormat: '问卷标题',
        description: '感谢您参加本次问卷调查，现在我们就马上开始吧。',
        finishMessage: '您已完成本次问卷，感谢您的帮助与支持。',
        questions: [],
        files: [],
        ownIdReplace: true,
        pager: false,
      })
        .then((res) => {
          loading.close()
          this.$router.push({
            name: 'createItem',
            query: {
              questionnaireId: res.questionnaireId,
            },
          })
        })
        .catch(() => {
          loading.close()
        })
    },
    async checkSurveyAdmin() {
      const userCode = this.user.ldap
      return request('checkSurveyAdmin', { userCode }).then((res) => {
        this.isSurveyAdmin = res
      })
    },
    async onPullingDown(done) {
      this.currentPage = 1
      //模拟请求更新数据
      await this.getListData()
      this.$refs['scroll'].forceUpdate()
    },
    onPullingUp(done) {
      //如果是最后一页
      if (this.currentPage === this.totalPage) {
        console.log(this.currentPage)
        this.$refs['scroll'].forceUpdate()
        return
      }
      this.currentPage = this.currentPage + 1
      this.getListData(true)
    },
    scrollTo(mark) {
      const scrollDom = document.querySelector('.scroll-y')
      scrollDom.scrollTop =
        document.getElementById(`nav-${mark}`).offsetTop - scrollDom.offsetTop
    },
    closeWebApp() {
      this.$router.push('/home')
    },
    getTips() {
      console.log('获取提示...')
      let uat = 'https://uat.rwork.crc.com.cn/docs/dock9BSwPFosbD5j7navMrJJFlb'
      let prd = 'https://app.rwork.crc.com.cn/docs/dock9YvmLiHRmBlcdpPuYaSDzrc'
      window.location.href =
        process.env.VUE_APP_H5_ENV !== 'production' ? uat : prd
    },
  },
}
